
import { CustomModal } from "../../CustomModal";
import { useOperador } from '../../../../context/OperadorContext'
import { useAuth } from '../../../../context/AuthContext'
import jwtDecode from "jwt-decode";
import { useChatWhatsApp } from "../../../../context/ChatWhatsAppContext";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useClear } from "../../../../hooks/useClear";

interface TransferModalProps {
  open: boolean;
  onClose: () => void;
  chatId: string;
}

export const TransferModal = ({
  open,
  onClose,
  chatId
}: TransferModalProps) => {
  const queryClient = useQueryClient()
  const [loading, setLoading] = useState(false)
  const { loadFilaTransferencia } = useOperador()
  const { cookies, } = useAuth()
  const { transferQueue } = useChatWhatsApp()
  const { clearData } = useClear()
  const decoded = jwtDecode(cookies?.token || '') as any;


  const onTransfer = async () => {
    setLoading(true)
    try {
      const fila = await loadFilaTransferencia(decoded?.id_loja,)
      // console.log(fila)
      await transferQueue({ chatId, queue: fila.fila_transferencia, token: cookies?.whatsapp?.token || '' })
      await queryClient.refetchQueries({ queryKey: ['transbordo-atendimento'] })
    } catch (error) {
      console.error(error)
    } finally {
      clearData()
      setLoading(false)
      onClose()
    }
  }


  return (
    <CustomModal
      isOpen={open}
      onClose={onClose}
      title="Transferir atendimento"
      width="w-[30%]"
    >
      <div>
        <div className="flex items-center justify-center flex-col px-4">
          <p className="font-medium text-center text-lg m-2 text-gray-800 w-full">Deseja transferir este atendimento?</p>
          <div className="flex items-center gap-4 text-sm w-full">
            <button type="button" className="bg-red-600 text-white px-4 py-2 rounded-md mt-4 w-full" onClick={onClose}>Cancelar</button>

            <button
              type="button"
              disabled={loading}
              className="bg-green-600 text-white mt-4 px-4 py-2 rounded-md w-full disabled:opacity-50 flex items-center justify-center gap-2"
              onClick={onTransfer}
            >
              {loading && (
                <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" />
              )}
              {loading ? "Transferindo..." : "Transferir"}
            </button>
          </div>
        </div>
      </div>
    </CustomModal>
  )
}